module.exports = __webpack_public_path__ + "img/operationReservation.f361043c.png";